import type { SetThemeSuccessAction } from "domains/theme/actionTypes";
import { ThemeType } from "domains/theme/actionTypes";
import type { ThemeState } from "domains/theme/types";

export const initialState: ThemeState = {};

export const themeReducer = (state = initialState, action: SetThemeSuccessAction): ThemeState => {
  switch (action.type) {
    case ThemeType.SET_SUCCESS:
      return { ...state, selected: action.theme };

    default:
      return state;
  }
};
